import { render, staticRenderFns } from "./interface-authorize-detail.vue?vue&type=template&id=5cff7807&scoped=true"
import script from "./interface-authorize-detail.vue?vue&type=script&lang=js"
export * from "./interface-authorize-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff7807",
  null
  
)

export default component.exports